<script lang="ts">
	import { enhance } from '$app/forms';
	import { goto, invalidateAll } from '$app/navigation';
	import { parseFormData, parseFormErrors, testProductName } from '$lib/utils/zod';
	import ModalContainer from '@components/ModalContainer.svelte';
	import SubmitButton from '@components/SubmitButton.svelte';
	import InputText from '@components/form/InputText.svelte';
	import { modalStore } from '@skeletonlabs/skeleton';
	import toast from '@toast';

	let loading = false,
		formErrors: any;
</script>

<ModalContainer>
	<form
		method="POST"
		action="/productos?/search"
		class="flex flex-col space-y-4"
		use:enhance={({ cancel, formData }) => {
			if (loading) return cancel();

			// Zod validation
			const zodErrors = testProductName(parseFormData(formData));
			if (zodErrors) {
				formErrors = parseFormErrors(zodErrors);
				return cancel();
			}

			loading = true;
			return async ({ result }) => {
				if (result.type === 'redirect') {
					goto(result.location);
					modalStore.close();
				}
				if (result.type === 'failure') {
					toast.error(result.data?.message);
					if (result.data?.formErrors) {
						formErrors = result.data?.formErrors;
					} else {
						modalStore.close();
					}
				}
				loading = false;
			};
		}}
	>
		<InputText
			label="¿Qué producto estas buscando?"
			name="product_name"
			error={formErrors?.product_name}
			placeholder="Nombre del producto"
			class="font-semibold"
		/>

		<div class="grid grid-cols-2 gap-4 xsm:self-end">
			<button type="button" class="btn variant-ringed-surface" on:click={modalStore.close}>Cancelar</button>
			<SubmitButton {loading} text="Buscar" />
		</div>
	</form>
</ModalContainer>
